export type ViewMode = 'werkdagen' | 'werkrooster';

interface ViewToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

export function ViewToggle({ viewMode, onViewModeChange }: ViewToggleProps) {
  return (
    <div className="inline-flex rounded-lg border border-gray-200 p-1 bg-gray-50">
      <button
        type="button"
        onClick={() => onViewModeChange('werkrooster')}
        className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
          viewMode === 'werkrooster'
            ? 'bg-white shadow-sm text-gray-900'
            : 'text-gray-500 hover:text-gray-700'
        }`}
        aria-pressed={viewMode === 'werkrooster'}
      >
        Werkrooster
      </button>
      <button
        type="button"
        onClick={() => onViewModeChange('werkdagen')}
        className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
          viewMode === 'werkdagen'
            ? 'bg-white shadow-sm text-gray-900'
            : 'text-gray-500 hover:text-gray-700'
        }`}
        aria-pressed={viewMode === 'werkdagen'}
      >
        Werkdagen
      </button>
    </div>
  );
}
